import React, { Fragment, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { saasModernTheme } from 'common/theme/saasModern';
import ResetCSS from 'common/assets/css/style';
import { createClient } from '../../prismicio';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasModern/sassModern.style';
import Navbar from 'containers/SaasModern/Navbar';
import Footer from 'containers/SaasModern/Footer';
import { Mixpanel } from 'utils/mixpanel';
import MetaHead from 'common/components/MetaHead';
import BotPage from 'containers/SaasModern/BotPage/BotPage';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';

export default function page({
  bot,
  botPage,
  botTagsData,
  aiStoreData,
  locale,
  promotion
}) {
  useEffect(() => {
    Mixpanel.track('AI Store - AI Page view', {
      slug: bot.slug,
    });
  });
  return (
    
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <MetaHead
          title={botPage?.data?.meta_title}
          description={botPage?.data?.meta_description}
          keywords={botPage?.data?.meta_keywords}
          imageUrl={botPage?.data?.meta_image?.url}
        />
        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar locale={locale} promotion={promotion}/>
            </DrawerProvider>
          </Sticky>
          <BotPage
            botData={bot}
            botPage={botPage}
            botTagsData={botTagsData}
            aiStoreData={aiStoreData}
          />
          <Footer locale={locale} />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
}

export async function getServerSideProps({ params, locale }) {
  const client = createClient();
  const { uid } = params;
  const prismicLanguage = getPrismicLanguage(locale);
  try {
    // Fetch the data and convert the response to JSON
    const response = await fetch(
      `https://graphql.swiftask.ai/public/bot/${uid}`,
    );
    const aiStore = await fetch('https://graphql.swiftask.ai/public/bots_tag');
    const botTags = await fetch(
      'https://graphql.swiftask.ai/public/bot_tags_List',
    );
    const aiStoreData = await aiStore.json();
    const botTagsData = await botTags.json();
    const bot = await response.json();

    const sold = await client.getSingle('sold', {
      lang: prismicLanguage,
    });
  
    let botPage = {};
    try {
      botPage = await client.getByUID('bot_page', bot.slug, {
        lang: prismicLanguage,
      });
    } catch (error) {
      console.error('Error fetching botPage:', error.message);
    }

    return {
      props: {
        bot,
        botPage,
        aiStoreData,
        botTagsData,
        locale,
        promotion: sold.data,
      },
    };
  } catch (error) {
    console.error('Error fetching data:', error.message);
    return {
      notFound: true,
    };
  }
}
